import { Constant } from "@pdfking/tfunc"
import { BugIcon, FilesIcon, SlidersHorizontalIcon } from "lucide-react"

import type { SidebarViewDefinition } from "#public"

import { DebugView } from "./DebugView"
import { FilesView } from "./FilesView"
import { ImpositionView } from "./ImpositionView"

/**
 * Every sidebar panel, keyed by the name the URL state carries. `label` names
 * the rail button (its tooltip); where the backend library already names the
 * same thing it reads the `filecheck` table, so there is nothing to
 * re-translate here. Debug, which the backend never names, is its own text.
 */
export const SIDEBAR_VIEWS = {
  files: {
    align: "top",
    component: FilesView,
    icon: FilesIcon,
    label: panels => panels.FILE(),
  },
  imposition: {
    align: "top",
    component: ImpositionView,
    icon: SlidersHorizontalIcon,
    label: panels => panels.IMPOSITION(),
  },
  debug: {
    align: "bottom",
    component: DebugView,
    debug_only: true,
    icon: BugIcon,
    label: Constant("Debug"),
  },
} satisfies Record<string, SidebarViewDefinition>

/** The sidebar panels; each maps to an icon in the viewer's left rail. */
export type PdfviewSidebarView = keyof typeof SIDEBAR_VIEWS
